// source: proto/utilspb/pagination.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.utilspb.Pagination', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.utilspb.Pagination = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.utilspb.Pagination.repeatedFields_, null);
};
goog.inherits(proto.utilspb.Pagination, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.utilspb.Pagination.displayName = 'proto.utilspb.Pagination';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.utilspb.Pagination.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.utilspb.Pagination.prototype.toObject = function(opt_includeInstance) {
  return proto.utilspb.Pagination.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.utilspb.Pagination} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.utilspb.Pagination.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageSize: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageNo: jspb.Message.getFieldWithDefault(msg, 2, 0),
    sortName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sortDirection: jspb.Message.getFieldWithDefault(msg, 4, ""),
    filterNamesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    filterValuesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.utilspb.Pagination}
 */
proto.utilspb.Pagination.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.utilspb.Pagination;
  return proto.utilspb.Pagination.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.utilspb.Pagination} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.utilspb.Pagination}
 */
proto.utilspb.Pagination.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageNo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortDirection(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addFilterNames(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addFilterValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.utilspb.Pagination.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.utilspb.Pagination.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.utilspb.Pagination} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.utilspb.Pagination.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getPageNo();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getSortName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSortDirection();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFilterNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getFilterValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
};


/**
 * optional uint32 page_size = 1;
 * @return {number}
 */
proto.utilspb.Pagination.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.utilspb.Pagination} returns this
 */
proto.utilspb.Pagination.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 page_no = 2;
 * @return {number}
 */
proto.utilspb.Pagination.prototype.getPageNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.utilspb.Pagination} returns this
 */
proto.utilspb.Pagination.prototype.setPageNo = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string sort_name = 3;
 * @return {string}
 */
proto.utilspb.Pagination.prototype.getSortName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.utilspb.Pagination} returns this
 */
proto.utilspb.Pagination.prototype.setSortName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string sort_direction = 4;
 * @return {string}
 */
proto.utilspb.Pagination.prototype.getSortDirection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.utilspb.Pagination} returns this
 */
proto.utilspb.Pagination.prototype.setSortDirection = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string filter_names = 5;
 * @return {!Array<string>}
 */
proto.utilspb.Pagination.prototype.getFilterNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.utilspb.Pagination} returns this
 */
proto.utilspb.Pagination.prototype.setFilterNamesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.utilspb.Pagination} returns this
 */
proto.utilspb.Pagination.prototype.addFilterNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.utilspb.Pagination} returns this
 */
proto.utilspb.Pagination.prototype.clearFilterNamesList = function() {
  return this.setFilterNamesList([]);
};


/**
 * repeated string filter_values = 6;
 * @return {!Array<string>}
 */
proto.utilspb.Pagination.prototype.getFilterValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.utilspb.Pagination} returns this
 */
proto.utilspb.Pagination.prototype.setFilterValuesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.utilspb.Pagination} returns this
 */
proto.utilspb.Pagination.prototype.addFilterValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.utilspb.Pagination} returns this
 */
proto.utilspb.Pagination.prototype.clearFilterValuesList = function() {
  return this.setFilterValuesList([]);
};


goog.object.extend(exports, proto.utilspb);
